import { Component, OnInit,OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute }  from '@angular/router';
import { AngularFirestore, QueryFn } from 'angularfire2/firestore';
import { Subscription } from 'rxjs';
import { EstadoItens, IEstadoItens } from '../../../../models/estadoItens.model';
import { DataModelComponent } from '../../../../models/data.model.component';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';



@Component({
  selector: 'app-estadoItens',
  templateUrl: './estado-itens.component.html',
  styleUrls: ['./estado-itens.component.scss']
})
export class EstadoItensComponent  extends DataModelComponent<IEstadoItens> implements OnInit{
  dataSource: Array<any> = [];
  estadosModel: EstadoItens;
  dataEvent: Subscription;
  pageSize = 5
  searchText : string = ''
  verInativos : boolean = false
  @ViewChild('grid') grid: MatDataGridComponent;
  colunas = [{field:"codigo",text:"Código"},
             {field:"nome",text:"Nome"},
             {field:"anterior",text:"Passo anterior"},
             {field:"proximo",text:"Próximo passo"},
             {field:"finalizado", text:"Estado finalizado"},
             {field:"info",text:"Informações"},
             {field:"ordem", text:"Ordem"}];

  constructor(private db: AngularFirestore, private router:Router) {
    super( {
       codigo: new FormControl(),
       nome: new FormControl(),
       anterior: new FormControl(),
       proximo: new FormControl(),
       finalizado: new FormControl(),
       info: new FormControl(),
       inativo: new FormControl(),
       ordem: new FormControl(),
    });
    this.estadosModel = new EstadoItens(db);
  }

  ngOnInit() { 
      this.pesquisar()
  }

  doPostItem(event){
    this.estadosModel.post(this.item);
    super.doPostItem(event);
  }
  doEditItem(event){
    super.doEditItem(event);
    if (this.inserting)
      this.doGerarCodigo();
  }
  getFilterAttrib(){
    return 'Somente inativos';
  }

  doCheckFilter(x:boolean){
    if(this.verInativos != this.grid.checkFilterValue){
      this.verInativos = this.grid.checkFilterValue;
      this.pesquisar()
    }
  }

  doItemClick(item:any){
    this.router.navigate(['/estadoItens/'+item.codigo]);
  }
  doGerarCodigo(){
    this.estadosModel.gerarNovoCodigo(r=>{
      this.item.codigo = r.valor;
    })
  }

  doSearch(value : string){
    this.searchText = value
    this.dataSource = []
    this.pesquisar()   
  }

  assignOrPush(data){
    console.log(data.length)
    if(! (this.dataSource && this.dataSource.length > 0)){
      this.dataSource = data
    }
    else{
       if(data && data.length > 0){
         let arr = []
          for(let elem of data){
            let idx = this.dataSource.findIndex((item)=> (item.codigo == elem.codigo))
            if(idx === -1){ // se não existe insere , existe atualiza 
              arr.push(elem)
            }
            else{
              this.dataSource[idx] = elem
            }
          }
          // se não atribuir os dados de uma vez, não atualiza a view 
          this.dataSource = [...this.dataSource,...arr] 
       }
    } 


  }

  pesquisar(startAfterCursor? : string){  

   /* this.estadosModel.snapshot(this.where(startAfterCursor),
    (data)=>  this.assignOrPush(data)
    ,false)*/
    let where : QueryFn = (elem)=>{
     return elem.where('inativo','==',this.verInativos)
    }

    this.estadosModel.snapshot(where,
    (data)=>  this.dataSource = data
    ,false)

  }

  where(startAfterCursor?)
  {

    let txt = this.searchText.trim()
    let nLimit = 6
    let where : QueryFn = (elem)=>{
      if(startAfterCursor){  
          return elem.limit(nLimit).orderBy('codigo')
          .where('inativo','==',this.verInativos).startAfter(startAfterCursor)
      }  
      else {
        if(!txt){
          return elem.limit(nLimit)
          .where('inativo','==',this.verInativos).orderBy('codigo')
        }      
        else if(new RegExp(/^\d+$/).test(txt)){
          return elem.limit(nLimit)
          .where('codigo','==',txt).where('inativo','==',this.verInativos)          
        } // se for número         
        else {
          return elem.limit(nLimit)
          .where('nome','==',txt).where('inativo','==',this.verInativos)
        }
         
      }  
    }
    return where

  }

  doPageChange(argEvent : any){
    if(argEvent.previousPageIndex < argEvent.pageIndex)  {
      if(this.dataSource && (this.dataSource.length > 0)){
       let startAfterCursor = this.dataSource[this.dataSource.length-1].codigo
       this.pesquisar(startAfterCursor)
      }
    }
  }
}
